/* This file was generated automatically. Do not edit manually. */

import { createAssistantAutocompletionRepository as assistantAutocompletion } from './assistantAutocompletion';
import { createAssistantChatRepository as assistantChat } from './assistantChat';
import { createAssistantGuestBillsRepository as assistantGuestBills } from './assistantGuestBills';
import { createAssistantIntegrationsRepository as assistantIntegrations } from './assistantIntegrations';
import { createAssistantLogsRepository as assistantLogs } from './assistantLogs';
import { createAssistantMessageReplyRepository as assistantMessageReply } from './assistantMessageReply';
import { createAssistantRoomstatusRepository as assistantRoomstatus } from './assistantRoomstatus';
import { createAssistantSmartTipsRepository as assistantSmartTips } from './assistantSmartTips';
import { createAssistantSummaryRepository as assistantSummary } from './assistantSummary';
import { createAssistantUserPromptsRepository as assistantUserPrompts } from './assistantUserPrompts';

export * from './types';

export const assistantApiBasePath = '/api/atlas/v1/assistant';

export const assistantRestRepositoryFactories = {
    assistantAutocompletion,
    assistantChat,
    assistantGuestBills,
    assistantIntegrations,
    assistantLogs,
    assistantMessageReply,
    assistantRoomstatus,
    assistantSmartTips,
    assistantSummary,
    assistantUserPrompts,
};
